import { Box, Button, Stack, Typography } from '@mui/material';
import SubCategory from 'components/Category/components/SubCategory';
import { MenuItem } from 'generated/graphql';
import useMenuSlugParser from 'hooks/useMenuSlugParser';
import Link from 'next/link';
import { colors } from 'styles/theme/colors';
import { useServerTranslation } from 'hooks/useServerTranslation';
import { ItemLink } from '../../ItemLink';
import { LevelThreeGrid } from '../../LevelThreeGrid';
import { LevelThreeBackButton } from '../../LevelThreeBackButton';

type LevelThreeCategoryProps = {
    showingSubCategory: MenuItem;
    closeSubMenu: () => void;
};

export function LevelThreeCategory(props :LevelThreeCategoryProps) {
    const { showingSubCategory, closeSubMenu } = props;
    const { parseSlug } = useMenuSlugParser();
    const { t } = useServerTranslation();

    return (
        <>
            <LevelThreeBackButton onClick={closeSubMenu} />
            <Box sx={{
                padding: 6,
                paddingTop: 3,
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'center',
            }}
            >
                <Button
                    disableRipple
                    href={parseSlug(showingSubCategory)}
                    LinkComponent={Link}
                    sx={{
                        '&:hover': {
                            backgroundColor: 'transparent',
                            color: colors.pink2,
                        },
                    }}
                >
                    <Stack rowGap={1}>
                        <SubCategory
                            menuItem={showingSubCategory}
                            height={60}
                            buttonProps={{ href: undefined }}
                            typographyProps={{
                                variant: 'h3',
                                sx: {
                                    textAlign: 'center',
                                    fontWeight: 600,
                                    marginTop: '10px',
                                },
                            }}
                        />
                        <Typography
                            variant="myCustomersBody"
                            color={colors.black}
                            textAlign="center"
                        >
                            {t('navigation.show-all')}
                        </Typography>
                    </Stack>
                </Button>
            </Box>
            <LevelThreeGrid
                columnWidth={200}
                maxWidth={800}
                rowGap={1}
                rows={6}
            >
                {showingSubCategory?.items.map((item, itemIndex) => (
                    <ItemLink
                        item={item}
                        key={itemIndex}
                    />
                ))}
            </LevelThreeGrid>
        </>
    );
}
